import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { CalendarFilter } from "@/types";
import { LoginUser } from "@/types/Component";

Vue.use(Vuex)

interface State {
    accsessToken: string;
    loginUser: LoginUser;
    tenantId: string;
    currentPage: string;
    parentPage: string;
    calendarFilter: CalendarFilter;
    isTenantChanged:boolean;
    notificationCount:string;
    producerApprovalCount:string;
    deleteTenantAlertPopUp :boolean
}

const store = new Vuex.Store({

    state: {
        accsessToken: null,
        loginUser: null,
        tenantId: null,
        currentPageName: null,
        parentPageName: null,
        parentPageNames: [],
        calendarFilter: null,
        isInputChanged: false,
        isHiddenSwitched: false,
        isTenantChanged:false,
        notificationCount:null,
        producerApprovalCount:null,
        deleteTenantAlertPopUp:false,
        reloadFromHeader:false
    },

    getters: {
        accsessToken(state) {
            return state.accsessToken
        },
        loginUser(state) {
            return state.loginUser
        },
        tenantId(state) {
            return state.tenantId
        },
        currentPageName(state) {
            return state.currentPageName
        },
        parentPageName(state) {
            return state.parentPageName
        },
        parentPageNames(state) {
            return state.parentPageNames
        },
        calendarFilter(state) {
            return state.calendarFilter
        },
        isInputChanged(state) {
            return state.isInputChanged
        },
        isHiddenSwitched(state) {
            return state.isHiddenSwitched
        },
        isTenantChanged(state){
            return state.isTenantChanged
        },
        notificationCount(state){
            return state.notificationCount
        },
        producerApprovalCount(state){
            return state.producerApprovalCount
        },
        deleteTenantAlertPopUp(state){
            return state.deleteTenantAlertPopUp
        },
        reloadFromHeader(state){
            return state.reloadFromHeader
        }
    },

    mutations: {
        setAccsessToken(state, payload) {
            state.accsessToken = payload.accsessToken
        },
        updateLoginUser(state, payload) {
            state.loginUser = payload.loginUser
        },
        setLastTenantId(state, payload) {
            state.tenantId = payload.tenantId
        },
        setCurrentPageName(state, payload) {
            state.currentPageName = payload.currentPageName
        },
        setParentPageName(state, payload) {
            state.parentPageName = payload.parentPageName
        },
        setParentPageNames(state, payload) {
            state.parentPageNames = payload.parentPageNames
        },
        setCalendarFilter(state, payload) {
            state.calendarFilter = payload.calendarFilter
        },
        setIsInputChanged(state, payload) {
            state.isInputChanged = payload.isInputChanged
        },
        setIsHiddenSwitched(state, payload) {
            state.isHiddenSwitched = payload.isHiddenSwitched
        },
        setIsTenantChanged(state, payload){
            state.isTenantChanged = payload.isTenantChanged
        },
        setNotificationCount(state,payload){
            state.notificationCount = payload.notificationCount
        },
        setProducerApprovalCount(state,payload){
            state.producerApprovalCount = payload.producerApprovalCount
        },
        setDeleteTenantAlertPopUp(state,payload){
            state.deleteTenantAlertPopUp = payload.deleteTenantAlertPopUp
        },
        setReloadFromHeader(state,payload){
            state.reloadFromHeader = payload.reloadFromHeader
        }
    },

    actions: {
        doUpdateSession({ commit }, accsessToken) {
            commit('setAccsessToken', { accsessToken })
        },
        doUpdateLoginUser({ commit }, loginUser) {
            commit('updateLoginUser', { loginUser })
        },
        doUpdateLastTenantId({ commit }, tenantId) {
            commit('setLastTenantId', { tenantId })
        },
        doUpdateCurrentPageName({ commit }, currentPageName) {
            commit('setCurrentPageName', { currentPageName })
        },
        doUpdateParentPageName({ commit }, parentPageName) {
            commit('setParentPageName', { parentPageName })
        },
        doUpdateParentPageNames({ commit }, parentPageNames) {
            commit('setParentPageNames', { parentPageNames })
        },
        doUpdateCalendarFilter({ commit }, calendarFilter) {
            commit('setCalendarFilter', { calendarFilter })
        },
        doUpdateIsInputChanged({ commit }, isInputChanged) {
            commit('setIsInputChanged', { isInputChanged })
        },
        doUpdateIsHiddenSwitched({ commit }, isHiddenSwitched) {
            commit('setIsHiddenSwitched', { isHiddenSwitched })
        },
        doUpdateIsTenantChanged({ commit },isTenantChanged){
            commit('setIsTenantChanged',{ isTenantChanged })
        },
        doUpdateNotificationCount({commit},notificationCount){
            commit('setNotificationCount',{notificationCount})
        },
        doUpdateProducerApprovalCount({commit},producerApprovalCount){
            commit('setProducerApprovalCount',{producerApprovalCount})
        },
        doUpdateDeleteTenantAlertPopUp({commit},deleteTenantAlertPopUp){
            commit('setDeleteTenantAlertPopUp',{deleteTenantAlertPopUp})
        },        
        doUpdateReloadFromHeader({commit},reloadFromHeader){
            commit('setReloadFromHeader',{reloadFromHeader})
        }        
    },

    plugins: [createPersistedState({ storage: window.sessionStorage })]
})
export default store
